import React, { FC, useCallback, useState } from 'react';
import { Box } from '@chakra-ui/react';

import { EquipmentModel } from '@app/api/models/equipment';
import { useFetchData, useApi } from '@app/hooks';

import { useColumns } from './columns';
import SelectField from '../common/select-field';
import { Paper } from '../common/paper';
import { QueryTable } from '../common/table/query-table';

const filterOptions = [
  { id: 1, name: 'Активные' },
  { id: 2, name: 'Не активные' },
];

const EquipmentsGuideTable: FC = () => {
  const [activeFilter, setActiveFilter] = useState<EntityBase | undefined>({
    id: 1,
    name: 'Активные',
  });

  const api = useApi();

  const [fetchData] = useFetchData<EquipmentModel>({ method: api.equipments.getEquipmentsGuides });
  const columns = useColumns();
  
  return (
    <>
      <Box mb={2}>
        <Paper>
          <Box px={6} py={4} display="flex">
            <Box mr={2} minWidth={400}>
              <SelectField
                id="isDone"
                name="isDone"
                label="Активные/Не активные"
                options={filterOptions}
                value={activeFilter}
                onChange={setActiveFilter}
                clearable={false}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
      <QueryTable<EquipmentModel>
        title="Справочник моделей ХО"
        fetchData={useCallback((params) => fetchData({ ...params, filterRaw: { 
          ...params.filterRaw, is_visible: activeFilter.id === 1 ? 'true' : 'false'
        }}), [activeFilter])}
        columns={columns}
        key={activeFilter.id}
        canDownload
      />
    </>
  );
};

export default EquipmentsGuideTable;
